namespace GeniuzPOS.Administration {
    export enum PsParaGenTypeAllowSaleOverStock {
        AllowSaleOverStock = 0,
        AllowSaleOverStock1 = 1
    }
    Serenity.Decorators.registerEnumType(PsParaGenTypeAllowSaleOverStock, 'GeniuzPOS.Administration.PsParaGenTypeAllowSaleOverStock', 'Administration.PsParaGenTypeAllowSaleOverStock');
}
